(ns ui.view.counterparty-diligence.pdf-util
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.util :as cu]
   [oops.core :as oops]
   [common.schema.entities.counterparty-diligence.templates.util :as template-util]
   [ui.util :as uu]))

(def start-new-page-prefix "PAGE_")

(defn html->pdfmake-elements
  [html-str]
  (js/htmlToPdfmake (clj->js html-str)))

(defn html->pdfmake-content
  [html-str styles]
  (let [paragraphs (->> (string/split html-str "<p>")
                        (mapcat (fn [p]
                                  (string/split p "</p>")))
                        (remove cu/empty-value?))]
    (->> paragraphs
         (map (fn [p]
                {:text  (html->pdfmake-elements p)
                 :style (:paragraph-style styles)})))))

(defmulti to-pdfmake-content :data-type)

(defmethod to-pdfmake-content :default
  [args]
  (js/console.log "Data type not supported to PDFMake conversion " args)
  {:text  (str (:value args))
   :style :value})

(defmethod to-pdfmake-content :data.type/text-simple
  [args]
  {:text  (str (:value args))
   :style :value})

(defmethod to-pdfmake-content :data.type/text-multiline
  [args]
  {:text  (str (:value args))
   :style :value})

(defmethod to-pdfmake-content :data.type/file
  [{:keys [value attachments]}]
  {:text  (if (seq value)
            (->> value
                 (mapv #(get attachments %))
                 (mapv :attachment/filename)
                 (string/join "; "))
            "")
   :style :value})

(defmethod to-pdfmake-content :data.type/boolean
  [args]
  (let [value (:value args)]
    {:text  (cond (false? value)
                  (loc/tr :false)
                  (nil? value)
                  ""
                  :else
                  (loc/tr :true))
     :style :value}))

(defmethod to-pdfmake-content :data.type/keyword
  [{:keys [value options lang-kw]}]
  (let [option (->> options
                    (cu/filter-by :value value)
                    first)
        option-label (cond
                       (map? (:translations option))
                       (get-in option [:translations lang-kw])

                       (map? (:label option))
                       (get-in option [:label lang-kw])

                       :else (:label option))]
    {:text  option-label
     :style :value}))

(defmethod to-pdfmake-content :data.type/date
  [{:keys [value date-format]}]
  {:text  (uu/format-date value date-format)
   :style :value})

(defmulti to-pdfmake-content-complex :editor-type)

(defmethod to-pdfmake-content-complex :default
  [args]
  (let [edn-type (:edn-data-type args)]
    (js/console.log "EDN NOT FOUND " edn-type)
    {:text  (str (:value args))
     :style :value}))

(defmethod to-pdfmake-content-complex :editor.type/signatory-list
  [{:keys [value]}]
  {:stack (->> value
               (map (fn [{:keys [full-name email]}]
                      {:text  (str full-name " - " email)
                       :style :value})))})

(defmethod to-pdfmake-content-complex :editor.type/nationality-list
  [{:keys [value answers lang-kw]}]
  (let [rows (if (some? value)
               value
               ;; legacy single nationality fallback for answers saved before
               ;; the multi-nationality field
               (when answers
                 (template-util/nationality-rows answers)))]
    {:text  (template-util/nationality-rows->display rows lang-kw)
     :style :value}))

(defmethod to-pdfmake-content :data.type/vector
  [args]
  (to-pdfmake-content-complex args))

(defmethod to-pdfmake-content-complex :editor.type/entity-list
  [{:keys [value label lang-kw date-format table-columns item-template]}]
  (let [field-lookup (->> item-template
                          :template/schema
                          (mapv (fn [[field field-config]]
                                  [field (assoc field-config :field field)]))
                          (into {}))
        table-title (get label lang-kw)]
    (if (cu/empty-value? value)
      {:stack [""]}
      {:margin [0 10 0 10]
       :table
       {:widths     (->> table-columns
                         (mapv (fn [_]
                                 "*")))
        :headerRows (if table-title 2 1)
        :keepWithHeaderRows 1
        :body       (concat
                     (when table-title
                       [(->> table-columns
                             (map-indexed
                              (fn [idx _]
                                (if (zero? idx)
                                  {:text table-title
                                   :colSpan (count table-columns)
                                   :margin      [0 2 0 2]
                                   :border      [true true true true]
                                   :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                   :fillColor   "#EEE"}
                                  {}))))])
                     [(->> table-columns
                           (mapv (fn [{:keys [label]}]
                                   {:text        (get label lang-kw)
                                    :style       :table-header
                                    :margin      [0 2 0 2]
                                    :border      [true true true true]
                                    :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                    :fillColor   "#EEE"})))]
                     (->> value
                          (mapv
                           (fn [entity]
                             (->> table-columns
                                  (mapv (fn [{:keys [field]}]
                                          (let [value (get entity field)
                                                field-config (get field-lookup field)
                                                text-value (-> field-config
                                                               (assoc :value value
                                                                      :lang-kw lang-kw
                                                                      :date-format date-format)
                                                               to-pdfmake-content
                                                               :text)]
                                            {:text        text-value
                                             :border      [true true true true]
                                             :style       :value
                                             :borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]}))))))))}})))

(defn to-pdfmake-entity
  [{:keys [template answers lang-kw recursive? attachments
           date-format e-signature-required?]}]
  (->>
   template
   :template/sections
   (filterv (fn [[_section-id section-config]]
              (let [{:keys [signatory-section?]} section-config]
                (if signatory-section?
                  e-signature-required?
                  true))))
   (sort-by (fn [[_section-id section-config]]
              (:ord section-config)))
   (map
    (fn [[_section-id section-config]]
      (let [visible-questions (->> section-config
                                   :fields
                                   (filterv (fn [field]
                                              (let [field-config (get-in template [:template/schema field])]
                                                (template-util/field-visible?
                                                 {:field field
                                                  :field-config field-config
                                                  :data answers
                                                  :e-signature-required? e-signature-required?}))))
                                   (mapv (fn [field]
                                           (-> template
                                               (get-in [:template/schema field])
                                               (assoc :field field)))))

            keep-together? (true? (:keep-together? section-config))

            ; This may totally break if template schema is changed
            table
            {:headerRows         1
             :widths             ["*"]
             :body               [[{:text        (get-in section-config [:title lang-kw])
                                    ;:style     :table-header
                                    :margin      [0 2 0 2]
                                    :border      [false false false true]
                                    :borderColor ["white" "white" "white" "white"]
                                    ;:fillColor "#FFFFFF"
                                    }]
                                  [{;:border      [true true true true]
                                    :border      [false false false true]
                                    ;:borderColor ["#DDD" "#DDD" "#DDD" "#DDD"]
                                    :borderColor ["white" "white" "white" "white"]
                                    ;:fillColor   "#FDFDFD"
                                    :stack       [(->> visible-questions
                                                       (mapcat
                                                        (fn [{:keys [label field editor-type] :as q}]
                                                          (concat
                                                           ;; Table label is rendered in the table 
                                                           (when (and (get label lang-kw)
                                                                      (not= editor-type :editor.type/entity-list))
                                                             [{:text  (get label lang-kw)
                                                               :style :label}])
                                                           (when-not recursive?
                                                             [(to-pdfmake-content
                                                               (assoc q
                                                                      :value (get answers field)
                                                                      :answers answers
                                                                      :lang-kw lang-kw
                                                                      :date-format date-format
                                                                      :attachments attachments))]))))

                                                       (vec))]}]]
             :dontBreakRows      keep-together?
             :keepWithHeaderRows 1}]
        [{;:style  "tableExample"
          :margin [0 20 0 0]
          :table  table}])))))

(defn recursively-build-entity-list-pages
  [{:keys [answers template lang-kw attachments
           date-format containing-entity-label]}]
  (let [entity-list-fields (->> template
                                :template/sections
                                (mapcat
                                 (fn [[_section-id section-config]]
                                   (->> section-config
                                        :fields
                                        (mapv (fn [field]
                                                (let [field-config (get-in template [:template/schema field])]
                                                  (-> field-config
                                                      (assoc :field field
                                                             :section-title (get-in section-config [:title lang-kw])
                                                             :entity-type-label (get-in field-config [:entity-label lang-kw])))))))))
                                (filterv (fn [{:keys [editor-type]}]
                                           (= editor-type :editor.type/entity-list))))]
    (if (empty? entity-list-fields)
      {:stack [""]}
      {:stack (->> entity-list-fields
                   (mapcat (fn [{:keys [field item-template entity-label
                                        item-display-string-fields]}]
                             (let [value (get answers field)
                                   entity-type-label (get entity-label lang-kw)]
                               (->> value
                                    (mapv (fn [entity]
                                            (let [entity-label
                                                  (->> item-display-string-fields
                                                       (mapv (fn [field]
                                                               (or (:field field)
                                                                   field)))
                                                       (mapv (fn [field]
                                                               (get entity field)))
                                                       (remove nil?)
                                                       (string/join " ")
                                                       string/trim)

                                                  stack-title (str entity-type-label " - " entity-label)

                                                  stack-title (if containing-entity-label
                                                                (str containing-entity-label " - " stack-title)
                                                                stack-title)]
                                              {:pageBreak :before
                                               :stack     [stack-title
                                                           (to-pdfmake-entity
                                                            {:answers     entity
                                                             :template    item-template
                                                             :lang-kw     lang-kw
                                                             :date-format date-format
                                                             :attachments attachments})

                                                           (recursively-build-entity-list-pages
                                                            {:answers                 entity
                                                             :template                item-template
                                                             :lang-kw                 lang-kw
                                                             :date-format             date-format
                                                             :attachments             attachments
                                                             :containing-entity-label stack-title})]}))))))))})))

(defn template->pdfmake-doc-definition
  [{:keys [template answers lang-kw work-in-progress? attachments
           date-format e-signature-required?]}]
  (let [form-title (-> template
                       :template/form-title
                       (get lang-kw))
        form-preface (-> template
                         :template/form-preface
                         (get lang-kw))]
    {:watermark (when work-in-progress?
                  {:text    "Work in progress"
                   :color   "red"
                   :opacity 0.1
                   :bold    true
                   :italics false})
     :content   [{:stack [{:text  form-title
                           :style :main-header}

                          (when-not (cu/empty-value? form-preface)
                            (html->pdfmake-content form-preface {:paragraph-style :preface}))

                          (to-pdfmake-entity {:answers               answers
                                              :template              template
                                              :lang-kw               lang-kw
                                              :date-format           date-format
                                              :attachments           attachments
                                              :e-signature-required? e-signature-required?})

                          (recursively-build-entity-list-pages {:answers                 answers
                                                                :template                template
                                                                :lang-kw                 lang-kw
                                                                :date-format             date-format
                                                                :attachments             attachments
                                                                :containing-entity-label nil})]}]
     #_:pageBreakBefore #_(fn [currentNode followingNodesOnPage nodesOnNextPage _previousNodesOnPage]
                            (let [current-node (js->clj currentNode :keywordize-keys true)
                                  following-nodes-same-page (js->clj followingNodesOnPage
                                                                     :keywordize-keys
                                                                     true)
                                  nodes-on-next-page (js->clj nodesOnNextPage :keywordize-keys true)
                                  explicit-page-break? (when-let [id (:id current-node)]
                                                         (and (string? id)
                                                              (string/starts-with?
                                                               id
                                                               start-new-page-prefix)))
                                  break-before? (or explicit-page-break?
                                                    (and (seq nodes-on-next-page)
                                                         (:stack current-node)
                                                         (->> following-nodes-same-page
                                                              (filter :stack)
                                                              (empty?))
                                                         (->> nodes-on-next-page
                                                              (first)
                                                              :stack
                                                              (not))))]
                              break-before?))
     :styles    {:main-header  {:fontSize 12
                                :bold     true
                                :margin   [0 0 0 20]}
                 :subheader    {:fontSize 15
                                :bold     true}
                 :table-header {:fontSize 12
                                :bold     true}
                 :quote        {:italics true}
                 :preface      {:fontSize  8
                                :alignment "justify"
                                :color     "#666666"
                                :margin    [0 0 0 4]}
                 :label        {:fontSize 8
                                :bold     false
                                :margin   [0 4 0 0]
                                :color    "#999999"}
                 :link         {:fontSize   11
                                :bold       false
                                :margin     [4 4 4 4]
                                :decoration "underline"
                                :color      "blue"}
                 :value        {:fontSize 11
                                :bold     false
                                :margin   [4 4 4 4]
                                :color    "#333333"}
                 :file         {:fontSize 11
                                :bold     false
                                :margin   [4 4 4 4]
                                :color    "#333333"}
                 :input-line   {:fontSize   11
                                :bold       false
                                :margin     [4 4 4 4]
                                :decoration "underline"
                                :color      "#333333"}}}))

(defn create-pdf
  [{:keys [template answers work-in-progress? attachments
           date-format e-signature-required?]}]
  (let [doc-definition (template->pdfmake-doc-definition
                        {:answers               answers
                         :template              template
                         :work-in-progress?     work-in-progress?
                         :attachments           attachments
                         :lang-kw               :en
                         :date-format           date-format
                         :e-signature-required? e-signature-required?})
        pdf-doc (oops/ocall js/pdfMake "createPdf" (clj->js doc-definition))]
    pdf-doc))

(defn create-and-open-pdf
  [{:keys [template answers work-in-progress? attachments
           date-format e-signature-required?]}]
  (let [doc (create-pdf {:answers               answers
                         :template              template
                         :date-format           date-format
                         :attachments           attachments
                         :work-in-progress?     work-in-progress?
                         :e-signature-required? e-signature-required?})]
    (oops/ocall doc "open")))
